const PropTypes = require('prop-types')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')
const isOwner = require('module/viewer/helpers/is_owner')

// component which renders children if the viewer is logged in viewing their own page
function OwnerComponent({ children }, { page, viewer }) {
    if (! isLoggedIn(viewer)) return null
    if (! isOwner(viewer, page)) return null
    return children
}
OwnerComponent.propTypes = {
    children: PropTypes.any,
}
OwnerComponent.contextTypes = {
    page: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
}

module.exports = {
    OwnerComponent,
}
